module.exports = __webpack_public_path__ + "static/media/lenscareVN.ec47b9a7.png";